var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRelatedSearches16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.50254C0 5.41655 2.18416 2.84069 5.09094 2.23653V4.65311C3.41198 5.12794 2.18176 6.67158 2.18176 8.50256C2.18176 10.7117 3.97263 12.5026 6.18177 12.5026H7.27271V14.9025H6.4C2.86538 14.9025 0 12.0372 0 8.50254ZM11.6363 14.5718C14.1726 13.7212 16 11.3253 16 8.50254C16 4.96792 13.1346 2.10254 9.6 2.10254H9.45458V4.50256H9.81812C12.0273 4.50256 13.8181 6.29342 13.8181 8.50256C13.8181 10.057 12.9315 11.4043 11.6363 12.0664V14.5718Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09094 0.502563L8.72731 3.30256L5.09094 6.10256V0.502563Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 10.9026L7.99999 13.7026L11.6364 16.5026V10.9026Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRelatedSearches16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;